export const PRELOADER_RESOURCE_NAME = 'preloader';
